import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const fetchCurrentCustomerDetails = async () => {
  try {
    const response = await axiosInstance.get(`/api/customer/me`);
    let data = response.data;
    return {
      success: true,
      data,
    };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání odběratele."
    );
    return { success: false, status, message };
  }
};

export const fetchCustomerContracts = async () => {
  try {
    const response = await axiosInstance.get(`/api/customer/smlouvy`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(error, "Chyba při načítání smluv.");
    return { success: false, status, message };
  }
};

export const changePassword = async (
  oldPassword,
  newPassword,
  confirmPassword
) => {
  try {
    await axiosInstance.patch(`/api/customer/change-password`, {
      oldPassword,
      newPassword,
      confirmPassword,
    });

    return { success: true };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Nepodařilo se změnit heslo. Zkuste to prosím později."
    );

    return { success: false, status, message };
  }
};

export const updateMfaSettings = async (email, telefon, mfaTyp) => {
  try {
    await axiosInstance.patch("/api/customer/mfa-settings", { email, telefon, mfaTyp });
    return { success: true };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Nastavení MFA se nepodařilo uložit."
    );
    return { success: false, status, message };
  }
};
